var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.67 13.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33,13.33A8.79,8.79,0,0,1,0,6.91a.82.82,0,0,1,0-.49A8.79,8.79,0,0,1,8.33,0a8.8,8.8,0,0,1,8.3,6.42.82.82,0,0,1,0,.49A8.8,8.8,0,0,1,8.33,13.33ZM1.71,6.67a7.11,7.11,0,0,0,6.62,5,7.12,7.12,0,0,0,6.63-5,7.12,7.12,0,0,0-6.63-5A7.11,7.11,0,0,0,1.71,6.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33,9.58a2.92,2.92,0,1,1,2.92-2.91A2.91,2.91,0,0,1,8.33,9.58Zm0-4.16A1.25,1.25,0,1,0,9.59,6.67,1.26,1.26,0,0,0,8.33,5.42Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.a6bd6d12df0ad83f196bb5ed16fa2d28.svg";
export { ForwardRef as ReactComponent };